import Splide from '@splidejs/splide';

let quoteSlider = document.getElementsByClassName('quote-slider');
let quoteSliderContent = document.getElementsByClassName('quote-slider-image');

document.addEventListener('DOMContentLoaded', function () {
    if (quoteSlider.length > 0) {
        for (let i = 0; i < quoteSlider.length; i++) {
            let splide = new Splide(quoteSlider[i], {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                rewind: true,
                pagination: false,
                arrows: true,
                width: '100%'
            });

            let content = new Splide(quoteSliderContent[i], {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                rewind: true,
                pagination: false,
                arrows: false,
                width: '100%'
            });

            let bar = splide.root.querySelector('.splide-progress-bar');

            splide.on('mounted move', function () {
                let end = splide.Components.Controller.getEnd() + 1;
                bar.style.width = String(100 * (splide.index + 1) / end) + '%';
            });

            splide.sync(content)
            splide.mount();
            content.mount();
        }
    }
});


